import React, { lazy, Suspense } from 'react';

const LazyKhachHang = lazy(() => import('./KhachHang'));

const KhachHang = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyKhachHang {...props} />
  </Suspense>
);

export default KhachHang;
